class BreadcrumbTracker {
  constructor() {
    this.pageHistory = [];
    this.maxHistoryLength = 8; // Adjust as needed
    
    // Load existing history from sessionStorage
    this.loadHistory();
    
    // Add current page to history
    const title = document.title.split('-')[0];
    this.addToHistory({
      url: window.location.pathname,
      title: title,
      timestamp: new Date().getTime()
    });

    // Listen for page changes if using client-side routing
    window.addEventListener('popstate', () => this.handlePageChange());
  }

  loadHistory() {
    const savedHistory = sessionStorage.getItem('pageHistory');
    this.pageHistory = savedHistory ? JSON.parse(savedHistory) : [];
    
  }

  saveHistory() {
    sessionStorage.setItem('pageHistory', JSON.stringify(this.pageHistory));
  }

  addToHistory(pageData) {
    // Don't add duplicate consecutive entries
    if (this.pageHistory.length && this.pageHistory[0].url === pageData.url) {
      return;
    }
    this.pageHistory.unshift(pageData);
    // Maintain max length
    if (this.pageHistory.length > this.maxHistoryLength) {
      this.pageHistory.pop();
    }

    this.saveHistory();
  }

  handlePageChange() {
    this.addToHistory({
      url: window.location.pathname,
      title: document.title,
      timestamp: new Date().getTime()
    });
  }

  getHistory() {
    return this.pageHistory;
  }
}
